export type { LogRequest, LogResponse } from './log-service';
export { doLog } from './log-service'
